import { CHATGPT_TRAVEL_PLANNER_CONTENT, CLAUDE_TRAVEL_PLANNER_CONTENT } from "../../marketing/content/featurePageContent";
import { FEATURE_PAGE_LOCALE_META } from "../../marketing/content/featurePageLocaleMeta";
import { faqPageLd, howToLd, softwareApplicationLd } from "../../marketing/seo/jsonLd";
import { NonEnglishLocale } from "i18n/urlLocale";
import { PageCtx } from "./ctx";
import { Assistant } from "./data";

const CONTENT: Record<Assistant, typeof CHATGPT_TRAVEL_PLANNER_CONTENT> = {
	chatgpt: CHATGPT_TRAVEL_PLANNER_CONTENT,
	claude: CLAUDE_TRAVEL_PLANNER_CONTENT,
};

const PATH = { chatgpt: "/chatgpt-travel-planner", claude: "/claude-travel-planner" } as const;

/**
 * SoftwareApplication, HowTo and FAQPage for the six translated pages, in their own language. The English
 * page gets these in <head> from marketingRoutes.tsx; locale routes get none there (generateLocalisedFeatureRoutes),
 * and building them in the head would put this page's seven locale files into every marketing page's bundle.
 * Google reads JSON-LD anywhere in the HTML, so the page renders it, server-side, from the same strings its FAQ
 * and setup sections show. The app card's name stays English, as on the other feature pages.
 */
export default function LocaleJsonLd({ ctx, lang }: { ctx: PageCtx; lang: NonEnglishLocale }) {
	const { assistant, tr, trA } = ctx;
	const content = CONTENT[assistant];
	const meta = FEATURE_PAGE_LOCALE_META[PATH[assistant]]?.[lang];
	const schemas = [
		softwareApplicationLd({
			baseUrl: "https://www.stippl.io",
			...content.softwareApplication,
			description: meta?.description ?? content.softwareApplication.description,
		}),
		howToLd({
			name: trA("howToUse.name"),
			description: trA("howToUse.description"),
			steps: content.howToSteps.map((_, i) => ({ name: trA(`howToSteps.${i}.name`), text: trA(`howToSteps.${i}.text`) })),
		}),
		faqPageLd(
			content.faqItems.map((_, i) => ({ question: trA(`faqItems.${i}.question`), answer: trA(`faqItems.${i}.answer`) })),
			tr("faq.h2")
		),
	];
	return (
		<>
			{schemas.map((schema, i) => (
				// "<" escaped so no string can close the script tag.
				<script key={i} type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(schema).replace(/</g, "\\u003c") }} />
			))}
		</>
	);
}
